::ng-deep .tooltip-wide .tooltip-inner{min-width:500px!important;max-width:600px!important}.text-danger-dark{color:#9e1b32;background-color:#fff}.text-bg-danger-dark{background-color:#9e1b32;color:#fff}
/*# sourceMappingURL=alert-overview-item.component-PRYI7CHI.css.map */
